import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appPreventEscClose]',
  standalone: true
})
export class PreventEscCloseDirective implements AfterViewInit, OnDestroy {
  /** 1️⃣  Browser’s native <dialog> “cancel” event */
  private cancelListener = (e: Event) => e.preventDefault();

  /** 2️⃣  DaisyUI’s global keydown on Escape */
  private keyListener = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopImmediatePropagation();   // ← stops DaisyUI / other libs
    }
  };

  constructor(private el: ElementRef<HTMLDialogElement>) {}

  ngAfterViewInit(): void {
    const dlg = this.el.nativeElement;
    // stop native behaviour
    dlg.addEventListener('cancel', this.cancelListener);
    // stop DaisyUI’s listener (listen in capture phase so we win)
    dlg.addEventListener('keydown', this.keyListener, true);
  }

  ngOnDestroy(): void {
    const dlg = this.el.nativeElement;
    dlg.removeEventListener('cancel', this.cancelListener);
    dlg.removeEventListener('keydown', this.keyListener, true);
  }
}
